import React from 'react';
import {SectionTitle} from 'components/items'
import makeTitle from 'function/makeTitle.js';


const sectionTitle = [
  {
    text: "Show",
    color: "default",
    break: false
  }, {
    text: "Solid",
    color: "main",
    break: false
  }, {
    text: "Teamwork",
    color: "default",
    break: false
  },{
    text: "Make",
    color: "default",
    break: true
  }, {
    text: "Solid",
    color: "main",
    break: false
  }, {
    text: "Cosmetics",
    color: "default",
    break: false
  },{
    text: "Create a ",
    color: "default",
    break: true
  }, {
    text: "Solid",
    color: "main",
    break: false
  }, {
    text: "Society",
    color: "default",
    break: false
  }
]

const SectionWithText = () => {
  return (
    <section className="SectionWithText">
      <div className="section-header">
        <div className="con">
          <SectionTitle text = {makeTitle(sectionTitle)} type = "center" withText = "false"/>
          <p className="section-text center">동구밭은 발달장애인 문제를 해결하는 소셜벤처입니다. <br />
우리는 발달장애인과 비장애인이 함께 탄탄한 팀워크를 보여주는 동구밭 팩토리에서<br />
액상제품보다 나은 고체화장품을 제조판매하며 발달장애인과 비장애인이 공존하는 튼튼한 사회를 만들고자 합니다.</p>
        </div>
      </div>
      
    </section>
  );
}

export default SectionWithText;